// 验证是否为blob格式
export function blobValidate(data) {
	return data.type !== 'application/json'
}

export function errorCode() {
	return {
		401: '认证失败，无法访问系统资源',
		403: '当前操作没有权限',
		404: '访问资源不存在',
		default: '系统未知错误，请反馈给管理员'
	}
}
/**
* 参数处理
* @param {*} params  参数
*/
export function tansParams(params) {
	let result = ''
	for (const propName of Object.keys(params)) {
	  const value = params[propName];
	  var part = encodeURIComponent(propName) + "=";
	  if (value !== null && value !== "" && typeof (value) !== "undefined") {
		if (typeof value === 'object') {
		  for (const key of Object.keys(value)) {
			if (value[key] !== null && value[key] !== "" && typeof (value[key]) !== 'undefined') {
			  let params = propName + '[' + key + ']';
			  var subPart = encodeURIComponent(params) + "=";
			  result += subPart + encodeURIComponent(value[key]) + "&";
			}
		  }
		} else {
		  result += part + encodeURIComponent(value) + "&";
		}
	  }
	}
	return result
  }